import EditorWindow from './EditorWindow';
import ResultsWindow from './ResultsWindow';
import SettingsWindow from './SettingsWindow';
import HelpWindow from './HelpWindow';

// Create a mapping of window types to their content components
export const WindowContentMap: Record<string, React.FC<{ windowId: string }>> = {
  editor: EditorWindow,
  results: ResultsWindow,
  settings: SettingsWindow,
  help: HelpWindow,
};

export {
  EditorWindow,
  ResultsWindow,
  SettingsWindow,
  HelpWindow
}; 